// 远程标准
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
          @reload="$reloadHandle"  @goBackIndex="goBackIndex" :initTableList="initTableList"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid ref="table-m1" v-bind="gridData" :stripe="true" border="default" :row-config="{ isHover: true }"
            show-overflow height="100%" @resizable-change="$vxeTableUtil.onColumnWitchChange"
            @custom="$vxeTableUtil.customHandle">
            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
<!--                  <vxe-button v-if="area_add" status="primary" class="button-sty" icon="el-icon-plus"-->
<!--                    @click="openEditDialog">新增-->
<!--                  </vxe-button>-->
                  <vxe-button v-if="areaFeeImport" status="primary" class="button-sty" icon="el-icon-top"
                    @click="$refs.excelUpload.show()">导入
                  </vxe-button>
                  <vxe-button v-if="areaFeeExport" status="primary" class="button-sty" icon="el-icon-download"
                    @click="doExcle">导出
                  </vxe-button>
                  <vxe-button v-if="sysnGdMap" status="primary" class="button-sty" icon="el-icon-download"
                              @click="sysGdData">同步高德远程点
                  </vxe-button>
                </div>
                <div class="fr">
                  <!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary"-->
                  <!--                              plain>重置-->
                  <!--                  </vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
                @submit="searchEvent" @reset="searchEvent">
                <vxe-form-item title="名称:" field="orderTypeName">
                  <template v-slot>
                    <el-input v-model="searchValue" size="small" clearable />
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>

            <template #aaa="{ row }">
              <div>
                <a href="javascript:void(0);" class="a-link" @click=openEditDialog(row.id);>
                  <el-tooltip effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                    <i class="el-icon-edit" />
                  </el-tooltip>
                </a>
                <!-- <a href="javascript:void(0);" v-if="area_add && row.areaLevel !== 4" class="a-link"
                  @click=openEditDialog(row.id)>
                  <el-tooltip effect="dark" content="添加" placement="top" popper-class="tooltip-skin">
                    <i class="el-icon-circle-plus-outline" />
                  </el-tooltip>
                </a> -->
              </div>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>


    <el-dialog style="padding: 40px 20px " :close-on-click-modal="false" :visible.sync="addDialogVisible" width="30%"
      top="5vh" :show-close="true" :before-close="addHandleClose" :title="addDialogTitle == 'edit' ? '编辑' : '新增'">
      <el-form :model="addForm" label-width="150px" ref="addRef" :rules="rules">
        <el-form-item label="父级">
          <el-input size="medium" v-model="addForm.parentName" :disabled="true" />
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input size="medium" :maxlength="20" v-model="addForm.areaName" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="区号">
          <el-input size="medium" :maxlength="20" v-model="addForm.areaCode" placeholder="请输入区号" />
        </el-form-item>
        <el-form-item label="外部对接码1">
          <el-input size="medium" :maxlength="10" v-model="addForm.code1" placeholder="请输入外部对接代码1" />
        </el-form-item>
        <el-form-item label="外部对接码2">
          <el-input size="medium" :maxlength="10" v-model="addForm.code2" placeholder="请输入外部对接代码2" />
        </el-form-item>
        <el-form-item label="区域结算等级" prop="name">
          <el-select v-model="addForm.settleLevel">
            <el-option label="默认" :value="0" />
            <el-option label="一级" :value="1" />
            <el-option label="二级" :value="2" />
            <el-option label="三级" :value="3" />
            <el-option label="四级" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="开启派工到人" prop="name">
          <el-select v-model="addForm.openAutoAssign">
            <el-option label="否" :value="0" />
            <el-option label="是" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="启用" prop="name">
          <el-select v-model="addForm.usable">
            <el-option label="禁用" :value="0" />
            <el-option label="启用" :value="1" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addHandleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="addData"
          v-if="(area_edit && addForm.id != null) || (area_add && addForm.id == null)">确 定</el-button>
      </span>
    </el-dialog>
    <!--excel 模板导入 -->
    <excel-upload ref="excelUpload" title="远程标准费用导入" url="/basic/basArea/importAreaFee"
                  temp-url="/admin/sys-file/local/file/importAreaFee.xlsx"
                  @refreshDataList="refreshChange"></excel-upload>
  </div>
</template>

<script>
import editView from './edit.vue';
import ExcelUpload from "@/components/upload/excel.vue";
import { initVxeTreeTable } from '@/const/crud/admin/treeTableWithPagination';
import pager from '@/components/pager/index.vue'
import { mapGetters } from "vuex";
import {doCheckExcle, doDownLoadExcle} from '@/api/intfDownloadRecord/downloadRecord.js'
import fileNames from "@/api/intfDownloadRecord/fileNames.js";
import api from "@/api/projectApi";

export default {
  name: 'remoteStandard',

  components: { editView, pager, ExcelUpload, },
  data() {
    return {
      area_edit: false,
      area_add: false,
      areaFeeImport: false,
      areaFeeExport: false,
      sysnGdMap:false,
      total: 0,
      getAreaDataUrl: '/basic/basArea/getById',
      updateDataUrl: '/basic/basArea/update',
      exportUrl: '/basic/basArea/exportAreaFee',
      addDataUrl: '/basic/basArea/add',
      requestParam: {
        searchCount: false,  // 是否分页
        areaName: "",  // 名称
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
        parentId: null,
      },
      addDialogTitle: '',
      addDialogVisible: false,
      addForm: {
        id: null,
        parentId: '',
        parentName: '',  // 父名称，显示用
        areaName: '',
        areaCode: '',
        code1: '',
        code2: '',
        settleLevel: 0,
        usable: 1,
        openAutoAssign: 0
      },
      rules: {
        name: [{ required: true }]
      },
      pageSizes: [10, 20, 100],
      gridData: {},
      showEdit: false,
      activeName: 'second',
      dataId: 0,
      searchValue: '',
      columns: [
        // { type: 'seq',title: '序号', width: 60, resizable: false, fixed: 'left' },
        { field: 'id', title: 'id', treeNode: true, width: 200 },
        { title: '名称', field: 'areaName', width: 160, },

        { title: '固定远程费(元)', field: 'lockDistanceFee', width: 120, },
        { title: '远程基数(km)', field: 'distanceBase', width: 100, },
        { title: '远程费率(元/km)', field: 'distanceFee', width: 100, },
        { title: '封顶远程费', field: 'topDistanceFee', width: 120, },
        { title: '远程点', field: 'distanceStartAddress', width: 120, },
        { title: '远程点经度', field: 'longitude', width: 120, },
        { title: '远程点纬度', field: 'latitude', width: 120, },
        {
          title: '启用状态', field: 'usable', width: 130, slots: {
            default: ({ row }) => {
              if (row.usable == 1) {
                return [
                  <div class="txt-status">
                    <span>启用</span>
                  </div>
                ];
              } else if (row.usable == 0) {
                return [
                  <div class="txt-status disable">
                    <span>禁用</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          width: 100, fixed: 'right', title: '', sortable: false, slots: {
            default: 'aaa'
          }
        }
      ]
    };
  },

  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }

  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.area_edit = this.permissions['area_edit']
    this.area_add = this.permissions['area_add']
    this.areaFeeImport = this.permissions['areaFeeImport']
    this.areaFeeExport = this.permissions['areaFeeExport']
    this.sysnGdMap = this.permissions['sysnGdMap']
  },
  methods: {
    goBackIndex() {
      this.activeName = 'second'
      this.showEdit = false
      this.flushed()
    },
    sysGdData(){
      this.$mask.open()
      this.$http({
        url: api.basArea.sysAreaGd,
        method: 'post',
        data: {
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$message.success("同步成功")
        this.$mask.close()
      }).catch(() => {
        this.$message({
          type: "error",
          message: "同步失败"
        });
        this.$mask.close()
      })
    },
    //导出
    doExcle() {
      // const  result =
      this.$mask.open()
      this.$objCopy(this.formData, this.requestParam)
      doCheckExcle(fileNames.areaFee).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(this.exportUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: '/basic/basArea/getListPage',
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.gridData = initVxeTreeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },


    // 搜索
    searchEvent() {
      this.requestParam.areaName = this.searchValue
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 关闭弹窗
    addHandleClose() {
      this.addDialogVisible = false;
      // this.$refs.addRef.resetFields();
      this.addForm = {
        id: null,
        parentId: '',
        parentName: '',  // 父名称，显示用
        areaName: '',
        areaCode: '',
        code1: '',
        code2: '',
        settleLevel: 0,
        usable: 0,
        openAutoAssign: 0
      }
    },

    // 重置
    resetEvent() {
      this.searchValue = ''
      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.areaName = ''
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
    // 编辑
    // openEditDialog(id) {
    //   this.addDialogTitle = 'edit'
    //   this.addDialogVisible = true
    //   this.$http({
    //     url: this.getAreaDataUrl,
    //     method: 'post',
    //     data: {id: id}
    //   }).then(res => {
    //     this.addForm = res.data.data
    //   })
    // },

    // 新增
    openEditDialog(id) {
      console.log(id, "5847");
      this.dataId = !id || typeof id == 'object' ? 0 : id;

      this.activeName = 'first';
      this.$openEditView('showEdit');


      // this.addDialogTitle = 'new'
      // this.addDialogVisible = true
      // this.$http({
      //   url: this.getAreaDataUrl,
      //   method: 'post',
      //   data: {id: id}
      // }).then(res => {
      //   this.addForm.parentId = res.data.data.id
      //   this.addForm.parentName = res.data.data.areaName
      // })
    },

    addData() {
      this.$http({
        url: this.addDialogTitle === 'new' ? this.addDataUrl : this.updateDataUrl,
        method: 'post',
        data: this.addForm
      }).then(res => {
        this.$message.success('操作成功')
        this.addHandleClose()
        this.flushed()
      })
    }
  }
};
</script>


<style lang="scss" scoped>
.is_new {
  display: none
}

.d-item {
  border-left: 1px solid #ededed;
}

.el-main {
  display: inline-block;
  height: 791.18px;
}

::v-deep .el-card__body,
.el-main {
  padding: 20px 8px;
}

.basic-container {
  padding: 0px 0px 8px 0px !important;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;

  tr th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);


  }
}

.pop_time {
  td {
    font-weight: 400;
    text-align: left;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #2A6494;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.massing {
  display: flex;

}

.detail-wrap .d-header {
  border-bottom: solid 1px #E9E9E9;
  height: 34px;
  line-height: 34px;
  margin: 7px 0px 6px 12px;
  padding: 0px 24px 0 14px;
  font-size: 13px;
  overflow: hidden;
  background-color: #FFF;
}

.detail-wrap .d-header .fl>i {
  color: #2A6494;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  margin-bottom: 1px;
  font-size: 14px;
  font-size: 14px;
}

.d-cont {
  border-bottom: 1px solid #ededed;
  padding-top: 20px;

}

.user {
  height: 802.18px;
  background-color: #fff;
  margin-left: 12px;

  &__tree {
    padding: 15px;
    border: 1px solid #ededed;
    width: 192px;
    height: 755px;
  }

  &__main {
    .el-card__body {
      padding-top: 0;
    }
  }
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 45px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.basic-container .el-card {
  width: 100%;
  height: 800px;
}


.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep.el-tree {
  width: calc(100% - 32px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: rgba(86, 86, 86, 0.96);
}


// 重新修改tree组件样式
.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}


/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
